// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujActionsBas.js
//  les actions de bas de page
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function SujActionsBas({ canRun, recapRunning, runNow, runRecaps, running, setShowRuns, sys }) {
  return (
    <>
      {/* Actions bas de page */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <button onClick={() => setShowRuns(true)}
          style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 8, padding: "7px 14px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
          🕒 Voir l'historique des passages
        </button>
        {canRun && (
          <button onClick={runNow} disabled={running || recapRunning}
            style={{ background: THEME.purpleDim, border: `1px solid ${THEME.purple}`, color: THEME.purple, borderRadius: 8, padding: "7px 14px", cursor: running ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 700, opacity: running ? 0.6 : 1 }}>
            {running ? "⏳ Analyse en cours…" : "🔄 Analyser la dernière fenêtre"}
          </button>
        )}
        {canRun && (
          <button onClick={runRecaps} disabled={running || recapRunning}
            style={{ background: THEME.goldDim, border: `1px solid ${THEME.gold}`, color: THEME.gold, borderRadius: 8, padding: "7px 14px", cursor: recapRunning ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 700, opacity: recapRunning ? 0.6 : 1 }}>
            {recapRunning ? "⏳ Génération…" : "✨ Régénérer les récaps"}
          </button>
        )}
        <span style={{ color: THEME.textDim, fontSize: 11, marginLeft: "auto" }}>
          Fenêtres de {sys.fenetre_heures || 6} h · modèle {sys.model || "—"}
        </span>
      </div>
    </>
  );
}
